export default "__VITE_ASSET__B$sBRSoW__"